import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import ScheduleIcon from "@mui/icons-material/Schedule";
import TuneIcon from "@mui/icons-material/Tune";
import CategoryIcon from "@mui/icons-material/Category";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import PropTypes from "prop-types";

import FeeHead from "./FeeHead";
import FeeBook from "./FeeBook";
import FeeConcession from "./FeeConcession";
import FeeReceipt from "./FeeReceipt";
import FeeApproval from "./FeeApproval";
import AcademicYears from "./AcademicYears";
import AttendanceFineRangeApprove from "./AttendanceFineRange";
import ProceedingHeaders from "./ProceedingHeaders";
import ExamPaperTemplate from "../Exams/ExamPaperTemplate";
import FeeStructureApprove from "./FeeStructureApprove";
function Approval() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  useEffect(() => {
    setLoading(false);
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const MenuCard = ({ title, icon, path, color = "#2196F3" }) => (
    <Grid item xs={12} sm={6} md={4} lg={2.4}>
      <MDButton
        fullWidth
        variant="gradient"
        size="large"
        startIcon={icon}
        sx={{
          height: 90,
          fontSize: "0.85rem",
          fontWeight: 700,
          letterSpacing: "0.2px",
          borderRadius: "12px",
          color: "#FFFFFF !important",
          background: `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
          boxShadow: `0 4px 12px ${color}40`,
          transition: "all 0.25s ease",
          "&:hover": {
            background: `linear-gradient(135deg, ${color} 0%, ${color}DD 100%)`,
            transform: "translateY(-4px)",
            boxShadow: `0 8px 20px ${color}60`,
          },
          "& .material-icons-round, & .material-icons": {
            fontSize: "28px",
            color: "#FFFFFF !important",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "28px",
            color: "#FFFFFF",
          },
        }}
        onClick={() => handleNavigate(path)}
      >
        {title}
      </MDButton>
    </Grid>
  );

  MenuCard.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    path: PropTypes.string.isRequired,
    color: PropTypes.string,
  };
  const renderContent = () => {
    switch (activeView) {
      case "feehead":
        return <FeeHead />;
      case "feebook":
        return <FeeBook />;
      case "feeconcession":
        return <FeeConcession />;
      case "feereceipt":
        return <FeeReceipt />;
      case "feeapproval":
        return <FeeApproval />;
      case "academicyears":
        return <AcademicYears />;
      case "attendancefinerange":
        return <AttendanceFineRangeApprove />;
      case "proceedingheaders":
        return <ProceedingHeaders />;
      case "exampapertemplate":
        return <ExamPaperTemplate />;
      case "feestructure":
        return <FeeStructureApprove />;
      default:
        return (
          <>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="fullWidth"
                TabIndicatorProps={{
                  sx: {
                    backgroundColor: ["#2196F3", "#FF9800"][tabValue],
                    height: 5,
                    borderRadius: "4px 4px 0 0",
                  },
                }}
              >
                {[
                  {
                    label: "APPROVALS",
                    icon: <CloudUploadIcon />,
                    color: "#2196F3",
                    bgColor: "rgba(33, 150, 243, 0.10)",
                  },
                  {
                    label: "ACTIONS",
                    icon: <TouchAppIcon />,
                    color: "#FF9800",
                    bgColor: "rgba(255, 152, 0, 0.12)",
                  },
                ].map((item, index) => (
                  <Tab
                    key={item.label}
                    icon={item.icon}
                    iconPosition="top"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 0.2,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 700,
                            letterSpacing: "0.1px",
                            lineHeight: 1.5,
                          }}
                        >
                          {item.label}
                        </Box>

                        {tabValue === index && (
                          <KeyboardArrowDownIcon
                            sx={{
                              fontSize: 30,
                              color: item.color,
                              strokeWidth: 2,
                              filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.25))",
                              mt: 0.2,
                            }}
                          />
                        )}
                      </Box>
                    }
                    sx={{
                      minHeight: 105,
                      py: 1.2,
                      fontWeight: 800,
                      color: `${item.color} !important`,
                      opacity: 1,
                      borderRadius: "10px 10px 0 0",
                      transition: "all 0.25s ease",
                      "& .MuiSvgIcon-root": {
                        fontSize: 34,
                        color: item.color,
                        transition: "transform 0.25s ease",
                      },
                      "&:hover": {
                        backgroundColor: item.bgColor,
                        "& > .MuiTab-iconWrapper": {
                          transform: "scale(1.12)",
                        },
                      },
                      ...(tabValue === index && {
                        backgroundColor: item.bgColor,
                      }),
                    }}
                  />
                ))}
              </Tabs>
            </Box>

            {tabValue === 0 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="FEE STRUCTURE"
                  icon={<AccountBalanceWalletIcon />}
                  path="feestructure"
                  color="#2196F3"
                />
                <MenuCard
                  title="FEE HEADS"
                  icon={<AccountBalanceWalletIcon />}
                  path="feehead"
                  color="#2196F3"
                />
                <MenuCard
                  title="FEE BOOKS"
                  icon={<MenuBookIcon />}
                  path="feebook"
                  color="#03A9F4"
                />
                <MenuCard
                  title="FEE CONCESSIONS"
                  icon={<AccountBalanceWalletIcon />}
                  path="feeconcession"
                  color="#1976D2"
                />
                <MenuCard
                  title="FEE ALLOWED"
                  icon={<AccountBalanceWalletIcon />}
                  path="feeapproval"
                  color="#5f93db"
                />
                <MenuCard
                  title="PROCEEDING HEADERS"
                  icon={<AccountBalanceWalletIcon />}
                  path="proceedingheaders"
                  color="#5f93db"
                />
                <MenuCard
                  title="ATTENDANCE FINE RANGE"
                  icon={<AccountBalanceWalletIcon />}
                  path="attendancefinerange"
                  color="#388bdf"
                />

                <MenuCard
                  title="EXAM PAPER TEMPLATE"
                  icon={<AccountBalanceWalletIcon />}
                  path="exampapertemplate"
                  color="#388bdf"
                />
              </Grid>
            )}

            {/* ACTIONS */}
            {tabValue === 1 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="ACADEMIC YEARS"
                  icon={<Icon>calendar_month</Icon>}
                  path="academicyears"
                  color="#FF9800"
                />
                <MenuCard
                  title="FEE RECEIPTS"
                  icon={<AccountBalanceWalletIcon />}
                  path="feereceipt"
                  color="#F4511E"
                />
              </Grid>
            )}
          </>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                {/* HEADER - Matching Library Management System card design */}
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#FFFFFF" }}>fact_check</Icon>

                    <MDTypography variant="h6" color="white">
                      MANAGE APPROVALS
                    </MDTypography>
                  </MDBox>

                  {activeView !== "home" ? (
                    <MDButton
                      variant="contained"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF",
                        backgroundColor: "rgba(255,255,255,0.18)",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.28)",
                        },
                      }}
                    >
                      Back to Approvals
                    </MDButton>
                  ) : (
                    <MDButton
                      variant="contained"
                      onClick={() => navigate("/dashboard")}
                      startIcon={<Icon>dashboard</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF !important",
                        backgroundColor: "rgba(255,255,255,0.18) !important",
                        boxShadow: "none !important",
                        "& .material-icons": {
                          color: "#FFFFFF !important",
                        },
                        "&:hover": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.18) !important",
                        },
                        "&:active": {
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                        },
                      }}
                    >
                      Dashboard
                    </MDButton>
                  )}
                </MDBox>

                {/* CONTENT */}
                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh"></MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Approval;
